<template>
  <div
    class="trainer-finish-message traefinmess"
    :class="{ traefinmess_loading: loading }"
  >
    <div
      v-if="!loading && gtoScoreGroup"
      class="traefinmess_gto_score"
    >
      <div class="traefinmess_gto_score_ring">
        <ProgressRing
          :max="gtoScoreNrm"
          :maxCircle="1"
          :getClr="num => getTrainerScoreGroup(gtoScore).clr"
          style="--stroke-width: 0.5em; --size: 7em; --clr-stroke-back: var(--clr-black-1)"
        >
          <template #center>
            <div
              v-if="gameNa"
              class="weight_700 text-large clr-grey"
            >
              N/A
            </div>
            <div
              v-else
              class="d-flex f-center f-column"
            >
              <div
                class="clr-grey uppercase"
                style="font-size: 0.7em"
              >
                {{ $tc('common.gto_score') }}
              </div>
              <div class="progress-ring_num">{{ numFixed(gtoScore * 100) }}%</div>
            </div>
          </template>
        </ProgressRing>
        <!-- <ProgressCircle
          class="trainplan_title_progress position-absolute icon_sbtn"
          :valueUnit="gtoScoreNrm * 100"
          :strokeWidthPx="3"
          style="--size: 1.75rem; --clr-stroke-back: var(--clr-black-1)"
        /> -->
      </div>
    </div>

    <div v-if="!loading">
      <div
        v-if="gtoScoreGroup"
        class="anim-flip-in traefinmess_gto_score_group"
      >
        <i
          class="mdi traefinmess_gto_score_group_icon"
          :class="correctnessGroup.icon"
          :style="`color:var(${correctnessGroup.color})`"
        ></i>
        <div class="traefinmess_gto_score_group_text">
          {{ $t(`practice.${correctnessGroup.res_id}`) }}
        </div>
      </div>
      <TrainerStreetBtns
        v-if="hasStreets"
        :namespace="namespace"
        :historyHand="historyHand"
        :loading="loading"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import ProgressRing from '@/components/lib/ProgressRing'
import { getTrainerScoreGroup } from '@/helpers/trainer'
// import { getCorrectnessActionGroups } from '@/helpers/constants'
import TrainerStreetBtns from '@/components/Trainer/TrainerStreetBtns'
// import mock_trainer_history from './mock_trainer_history'

export default {
  name: 'TrainerFinishMessage',
  components: {
    // TrainerStats,
    ProgressRing,
    TrainerStreetBtns,
  },
  mixins: [format_mix],
  props: {
    // stats: Object,
    namespace: { String, required: true },
    loading: Boolean,
    hasStreets: { type: Boolean, default: true },
    historyHand: Object,
    hasSounds: Boolean,
  },
  methods: {
    handleStreetClick(item) {
      const spot_id = item.correctness.worst_spot_id
      this.$store.dispatch(`${this.namespace}/trainer_auto_new_hand_stop`)
      this.$store.dispatch('poker_replay_spot', {
        namespace: this.namespace,
        spot_id,
        hasSounds: this.hasSounds,
      })
    },
    getTrainerScoreGroup(num) {
      return getTrainerScoreGroup(num)
    },
  },
  computed: {
    correctness() {
      return this.historyHand?.correctness || null
    },
    gameNa() {
      return this.correctness?.game_na
    },
    correctnessGroup() {
      return this.correctness?.correctness_group || null
    },
    handStats() {
      return this.historyHand?.stats_hand || null
    },
    gtoScoreGroup() {
      if (!this.gameNa) {
        return this.handStats?.gto_score_group || null
      }
      return getTrainerScoreGroup(-1)
    },
    gtoScore() {
      if (!this.gameNa) {
        return this.handStats?.avg_gto_score || 0
      }
      return -1
    },
    gtoScoreNrm() {
      if (!this.gameNa) {
        const score = this.handStats?.avg_gto_score
        const res = score > 0 ? score : 0
        return res
      }
      return -1
    },
  },
}
</script>
<style lang="scss" scoped>
.traefinmess {
  background: rgba(255, 255, 255, 0.03);
  background: var(--clr-black-0-3);
  // background: var(--clr-black-1);
  // backdrop-filter: blur(10px);
  // border-radius: 2rem;
  border-radius: 1rem;
  // border-radius: 8px;
  // border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 2em;
  position: relative;
  min-width: 36em;
  min-height: 10.8em;
  padding: 2em 4em;
  overflow: hidden;
  z-index: 1;
  &_gto_score {
    position: relative;
    transition: 0.22s;
    &_ring {
      position: relative;
    }
    // &_group {
    //   display: flex;
    //   align-items: center;
    //   margin-bottom: 0.75em;
    //   &_icon {
    //     font-size: 2em;
    //     height: 1em;
    //     line-height: 1em;
    //   }
    //   &_text {
    //     padding: 0 0.75em 0 0.75em;
    //     font-size: 1.25em;
    //     font-weight: 700;
    //     text-transform: uppercase;
    //   }
    // }
    &_group {
      display: flex;
      align-items: center;
      margin-bottom: 0.25em;
      font-size: 1.5em;
      &_icon {
        height: 1em;
        line-height: 1em;
      }
      &_text {
        padding: 0 0.5em 0 0.5em;
        font-weight: 700;
        text-transform: uppercase;
      }
    }
  }
  &_item {
    opacity: 1;
    transition: opacity 0.22s;
  }
  &_loading {
    .traefinmess_streets,
    .traefinmess_gto_score {
      opacity: 0;
    }
    opacity: 1;
    animation: opacityPulse 2s infinite;
    --clr-back: var(--clr-white-0);
    background: var(--clr-back);
    @keyframes opacityPulse {
      0% {
        opacity: 0.05;
      }
      50% {
        opacity: 0.075;
      }
      100% {
        opacity: 0.05;
      }
    }
  }
}
@media (max-width: 1023px) {
  .traefinmess {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    flex-direction: column;
    grid-gap: 0.5em;
    padding: 2em 0;
    flex-wrap: wrap;
    width: 100%;
    min-width: unset;
    &_gto_score {
      &_ring {
        margin-top: 0;
      }
      &_group {
        justify-content: center;
        margin-top: 0.75em;
        margin-bottom: 1em;
      }
    }
  }
}
</style>
